import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkleHightlight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSparkleHightlight"><Path d="M12.5667 3.5H11.4333L9.025 9.025L3.5 11.4333V12.5667L9.025 14.975L11.4333 20.5L12.5667 20.5L14.975 14.975L20.5 12.5667L20.5 11.4333L14.975 9.025L12.5667 3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M2.5 2.5L5.5 5.5M21.5 2.5L18.5 5.5M2.5 21.5L5.5 18.5M21.5 21.5L18.5 18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSparkleHightlight;
